<template>


    <div class="grid">
        <loading :active="isLoadingModel" :can-cancel="true" color="#274461" :is-full-page="fullPage"></loading>
        <div class="col-12">
            <div class="card">
                <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems">
                <!--<template #item="{ item, props }">
                    <router-link v-if="item.to" v-slot="{ href, navigate }" :to="item.to" custom>
                        <a :href="href" v-bind="props.action" @click="navigate">
                            <span :class="[item.icon, 'text-color']" />
                            <span class="text-primary font-semibold">{{ item.label }}</span>
                        </a>
                    </router-link>
                </template>-->
                <template #item="{ item, props }">
                    <router-link v-if="item.to" v-slot="{ href, navigate }" :to="item.to" custom>
                        <a :href="href"  @click="navigate">
                            <span :class="[item.icon, 'text-color']" />
                            <span class="text-primary font-semibold">{{ item.label }}</span>
                        </a>
                    </router-link>
                    <a v-else :href="item.url" :target="item.target" v-bind="props.action">
                    <span class="text-color">{{ item.label }}</span>
                </a>
                </template>
            </Breadcrumb>
                <Toast />
                <div class="p-fluid formgrid grid" style="margin-top: 2%">
                    <div class="field col-12 md:col-2">
                        <span class="p-float-label">
                            <InputText type="text" format="number" v-model="search_name">
                            </InputText>
                            <label for="m_no">Name</label>
                        </span>
                    </div>

                    <div class="field col-12 md:col-2">
                        <span class="p-float-label">
                            <MultiSelect id="category" v-model="search_category" :options="category_dropdown"
                                :value="category_dropdown" optionLabel="name" filter></MultiSelect>
                            <label>Category</label>
                        </span>
                    </div>

                    <div class="field col-12 md:col-2">
                        <span class="p-float-label">
                            <MultiSelect id="category" v-model="search_singer" :options="singer_dropdown"
                                :value="singer_dropdown.value" optionLabel="name" filter></MultiSelect>
                            <label>Singer</label>
                        </span>
                    </div>

                    <div class="field col-12 md:col-2">
                        <Button style="background-color: #349CE4; border: 1px solid #349CE4;" icon="pi pi-search"
                            v-tooltip.bottom="'Search'" @click="search(1)" />
                    </div>
                </div>

                <DataTable :loading="loading" ref="dt" :lazy="true" :totalRecords="totalRecords" :paginator="true"
                    :value="products" v-model:selection="selectedProducts" :dataKey="columns[0]" :rows="limit"
                    :filters="filters" @page="onPage($event)"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25, totalRecords]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" responsiveLayout="scroll"
                    style="font-size: 12px" :rowHover="true" showGridlines>
                    <template #empty>
                        <b style="text-align:center">No records found.</b>
                    </template>
                    <template #header>
                        <div class="
                  flex flex-column
                  md:flex-row md:justify-content-between md:align-items-center
                ">
                            <h5 class="m-0"><b> Manage Song Master</b></h5>

                            <div>
                                <Button icon="pi pi-refresh" class="mr-2" v-tooltip.bottom="'Refresh'"
                                    @click="search(2)" style="background-color: #349CE4; border: 1px solid #349CE4;" />
                                <Button icon="pi pi-plus" v-tooltip.bottom="'Add'" @click="openNew"
                                    style="background-color: #349CE4; border: 1px solid #349CE4;" />
                            </div>
                        </div>
                        <div style="text-align:right;font-weight:bold;margin-top: 1%;"><span>Total Songs:</span>{{ totalRecords }}</div>
                    </template>

                    <Column header="No" style="text-align: center;">
                        <template #body="{ index }">
                            <span v-if="page_no == 1">{{ +index + +1 }}</span>
                            <span v-else>{{ (+index + 1) + limit * (page_no - 1) }}</span>
                        </template>
                    </Column>
                    <Column header="Status" style="min-width: 5rem ;text-align: center;" :field="columns[14]" >
                        <template #body="{ data }"> 
                            <div v-if="data.song_status">
                                <span v-if="data.song_status=='Active' ||data.song_status=='active'"><badge :value=data.song_status severity="success"></badge></span>
                                <span v-else-if="data.song_status=='InActive' ||data.song_status=='In Active'"><badge :value=data.song_status severity="warning"></badge></span>
                                <span v-else-if="data.song_status=='deleted' ||data.song_status=='Deleted'"><badge :value=data.song_status severity="danger"></badge></span>
                                <span v-else>-</span>
                            </div>
                            <span v-else>-</span>
                       
                        </template>
                    </Column>

                    

                    
                    <Column header="Image" style="text-align: center;min-width: 5rem ;">
                        <template #body="{ data }">
                           <img :src="data.song_image" alt="" style="height: 70%;width: 70%;"> 
                        </template>
                    </Column>
                    <Column header="Name" style="">
                        <template #body="{ data }">
                           {{ data.song_name }}
                        </template>
                    </Column>
                    <Column header="Category" :field="columns[9]" style="">
                        <template #body="{ data }">
                            {{ data.category }}
                        </template>
                    </Column>
                    

                    <Column header="Singer" :field="columns[3]" style="">
                        <template #body="{ data }">
                            {{ data.singer }}
                        </template>
                    </Column>
                    <Column header="Date" :field="columns[9]" style="text-align:left;">
                        <template #body="{ data }">
                            {{ convertDateFormat(data.date) }}
                        </template>
                    </Column>
                    <Column header="Play" :field="columns[10]" style="text-align:center; min-width: 12rem;">
                        <template #body="{ data }">
                            <audio :src="data.play_url" controls style="width: 100%;"></audio>
                        </template>
                    </Column>

                    <Column header="Action" headerStyle="min-width:10rem;">
                        <template #body="slotProps">
                            <Button icon="pi pi-pencil" title="Edit Client" v-tooltip.bottom="'Edit'"
                                class="p-button-rounded p-button-warning mr-2" @click="editProduct(slotProps.data)" />
                            <Button icon="pi pi-trash" v-tooltip.bottom="'Delete'"
                                class="p-button-rounded p-button-danger mt-2"
                                @click="confirmDeleteProduct(slotProps.data)" />
                        </template>
                    </Column>
                </DataTable>

                <Sidebar v-model:visible="productDialog" :baseZIndex="1000" position="full" @hide="onHide()">
                    <div class="col-12">
                        <div class="card">
                            <h5 v-if="product._id">Update Song Form</h5>
                            <h5 v-else>Add Song Form</h5>
                            <hr />
                            <div class="p-fluid formgrid grid">
                                <div class="p-field col-12 md:col-4">
                                    <label for="name">Song Name</label>
                                    <InputText id="name" class="label-gap" v-model="product.song_name" />
                                </div>

                                <div class="p-field col-12 md:col-4">
                                    <label for="singer">Singer</label>
                                    <InputText id="singer" class="label-gap" v-model="product.singer" />
                                </div>
                                <div class="p-field col-12 md:col-4">
                                    <label for="music_composer">Music Composer</label>
                                    <InputText id="music_composer" class="label-gap" v-model="product.composer" />
                                </div>
                                <div class="p-field col-12 md:col-4">
                                    <label for="lyrics_writer" class="label-gap">Lyrics Writer</label>
                                    <InputText id="lyrics_writer" v-model="product.lyrics_writer" />
                                </div>
                                <div class="p-field col-12 md:col-4">
                                    <label for="duration" class="label-gap">Duration(min)</label>
                                    <InputText id="duration" v-model="product.duration" disabled/>
                                </div>
                                <div class="p-field col-12 md:col-4">
                                    <label for="date">Date</label>
                                    <Calendar id="date" class="label-gap" v-model="product.date" showIcon/>
                                </div>

                                <div class="p-field col-12 md:col-3" v-if="!product._id">
                                    <label for="album_name" class="p-inputgroup label-button-group">Album Name</label>
                                    <Dropdown class="label-gap" id="status" v-model="album_selected"
                                        :options="album_dropdown" :value="album_dropdown.value"
                                        optionLabel="name" @change="categoryList" filter>
                                    </Dropdown>                                       
                                </div>

                                <div class="p-field col-12 md:col-1" v-if="!product._id">
                                    <Button label="Add Album" @click="add_album_dl()"
                                        class="p-button-link"></Button>
                                </div>
                                
                                <div class="p-field col-12 md:col-3" v-if="!product._id">
                                    <label for="category_name">Category Name</label>
                                        <Dropdown class="label-gap" id="status" v-model="category_selected"
                                            :options="category_dropdown" :value="category_dropdown.value"
                                            optionLabel="name" filter>
                                        </Dropdown>
                                </div>
                                <div class="p-field col-12 md:col-1" v-if="!product._id">
                                    <Button label="Add Category" @click="add_category_dl()"
                                        class="p-button-link"></Button>
                                </div>
                            </div>
                            <hr />
                            <div class="p-fluid formgrid grid mt-2">
                                <!-- <div class="p-field col-12 md:col-3">
                                    <label for="image">Image URL</label>
                                    <FileUpload class="p-button-primary" mode="basic" name="model[]" :auto="true"
                                        :custom-upload="true" choose-label="Chose" accept="image/*,video/*"
                                        @uploader="handleFileUpload($event)" style="
                                      box-shadow: 0 2px 6px rgba(0, 176, 176, 0.549);
                                      border-color: #00b0b0 !important;
                                      background-color: #00b0b0 !important;
                                      width: 100%;
                                      " />
                                    <div class="p-field col-12 md:col-2" v-if="previewImage" style="padding-top: 20px;">
                                        <img :src="previewImage" alt="Image"
                                            style="width: 170px; height: 120px;  border: 2px solid #D3D3D3; overflow: hidden;" />
                                    </div>
                                </div> -->
                                <div class="field col-12 md:col-2" style="margin-top: 1%">
               
                                    <Button
                                    style="box-shadow: 0 2px 6px rgba(0, 176, 176, 0.549);
                                      border-color: #00b0b0 !important;
                                      background-color: #00b0b0 !important;"
                                    label="Upload Image"
                                    @click="toggleShow"
                                    icon="pi pi-check"
                                    class="p-button"
                                    />
                                    <my-upload
                                    field="img"
                                    @crop-success="cropSuccess"
                                    langType="en"
                                    v-model="show_image"
                                    :width="width"
                                    :height="height"
                                    :url="url"
                                    :params="params"
                                    :headers="headers"
                                    img-format="png"
                                    :noCircle="true"
                                    :noRotate="false"
                                    >
                                    </my-upload>
                                    <div class="field col-12 md:col-2" style="margin-top: 5%;">
                                    <Image v-if="imgDataUrl" :src="imgDataUrl" alt="Image" width="150" preview />
                                    </div>
                                </div>
                                

                                <!-- <div class="p-field col-12 md:col-3" style="margin-left: 8%;">
                                    <label for="poster">Poster URL</label>
                                    <FileUpload class="p-button-primary" mode="basic" name="model[]" :auto="true"
                                        :custom-upload="true" choose-label="Chose" accept="image/*,video/*"
                                        @uploader="handleFileUpload_poster($event)" style="
                                      box-shadow: 0 2px 6px rgba(0, 176, 176, 0.549);
                                      border-color: #00b0b0 !important;
                                      background-color: #00b0b0 !important;
                                      width: 100%;
                                      " />
                                    <div class="p-field col-12 md:col-2" v-if="posterPreviewImage"
                                        style="padding-top: 20px;">
                                        <img :src="posterPreviewImage" alt="Image"
                                            style="width: 170px; height: 120px; border: 2px solid #D3D3D3; overflow: hidden;" />
                                    </div>
                                </div> -->

                                <div class="field col-12 md:col-2" style="margin-top: 1%">
               
                                    <Button
                                    style="box-shadow: 0 2px 6px rgba(0, 176, 176, 0.549);
                                      border-color: #00b0b0 !important;
                                      background-color: #00b0b0 !important;"
                                    label="Upload Poster"
                                    @click="toggleShow_poster"
                                    icon="pi pi-check"
                                    class="p-button"
                                    />
                                    <my-upload
                                    field="img"
                                    @crop-success="cropSuccess_poster"
                                    langType="en"
                                    v-model="show_image_poster"
                                    :width="width_poster"
                                    :height="height_poster"
                                    :url="url_poster"
                                    :params="params_poster"
                                    :headers="headers_poster"
                                    img-format="png"
                                    :noCircle="true"
                                    :noRotate="false"
                                    >
                                    </my-upload>
                                    <div class="field col-12 md:col-2" style="margin-top: 5%;">
                                    <Image v-if="imgDataUrl_poster" :src="imgDataUrl_poster" alt="Image" width="150" preview />
                                    </div>
                                </div>

                                <div class="p-field col-12 md:col-2" style="margin-top: 1%">
                                    <!-- <label for="play_url">Add song</label> -->
                                    <FileUpload class="p-button-primary" mode="basic" name="model[]" :auto="true"
                                        :custom-upload="true" choose-label="Choose Song" accept="audio/*"
                                        @uploader="handleFileUpload_song($event)" style="
                                      box-shadow: 0 2px 6px rgba(0, 176, 176, 0.549);
                                      border-color: #00b0b0 !important;
                                      background-color: #00b0b0 !important;
                                      width: 100%;
                                      " />
                                    
                                </div>
                                <div class="p-field col-12 md:col-2" v-if="preview_song_url != null"
                                        style="padding-top: 10px;">
                                        <audio :src="preview_song_url" controls></audio>
                                    </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 md:col-6">
                        <Button 
                        style="background-color: white; border: 1px solid #349CE4; color: #349CE4;"
                        v-if="product._id" label="UPDATE" icon="pi pi-check" class="p-button-success mr-1 mb-1"
                            @click="adduser" />
                        <Button 
                        style="background-color: white; border: 1px solid #349CE4; color: #349CE4;"
                        v-else label="ADD" icon="pi pi-check" class="p-button-success mr-1 mb-1"
                            @click="adduser" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Button 
                        style="background-color: #349CE4;"      
                        label="Cancel" icon="pi pi-times" class="p-button-primary mr-1 mb-1"
                            @click="onHide()" />
                    </div>
                </Sidebar>

                <Dialog v-model:visible="addAlbumDialog" :style="{ width: '450px' }" header="Album form" @hide="reset">
                    <div class="col-12">
                        <div class="card">
                            <hr />
                            <div class="p-fluid formgrid grid">
                                <div class="p-field col-12 md:col-12 mb-2">
                                    <label for="name1">Album Name</label>
                                    <InputText v-model="new_album_name" type="text" />
                                </div>
                                <div class="p-field col-12 md:col-12 mt-2">
                                    <label for="name1">Album URL</label>
                                    <InputText v-model="new_album_url" type="text" />
                                </div>
                                <div class="p-field col-12 md:col-6 mt-4">
                                    <Button label="Add" icon="pi pi-times" class="p-button-primary mr-1 mb-1"
                                        @click="add_new_album()" />
                                </div>
                                <div class="p-field col-12 md:col-6 mt-4">
                                    <Button label="Cancel" icon="pi pi-times" class="p-button-danger mr-1 mb-1"
                                        @click="reset" />
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog>

                <Dialog v-model:visible="addCategoryDialog" :style="{ width: '450px' }" header="Category form"
                    @hide="reset">
                    <div class="col-12">
                        <div class="card">
                            <hr />
                            <div class="p-fluid formgrid grid">
                                <div class="p-field col-12 md:col-12">
                                    <label for="name1">Category Name</label>
                                    <InputText v-model="new_category_name" type="text" />
                                </div>
                                <div class="p-field col-12 md:col-12">
                                    <label for="name1">Category URL</label>
                                    <InputText v-model="new_category_url" type="text" />
                                </div>
                                <div class="p-field col-12 md:col-6 mt-4">
                                    <Button label="Add" icon="pi pi-times" class="p-button-primary mr-1 mb-1"
                                        @click="add_new_category()" />
                                </div>
                                <div class="p-field col-12 md:col-6 mt-4">
                                    <Button label="Cancel" icon="pi pi-times" class="p-button-danger mr-1 mb-1"
                                        @click="addCategoryDialog = false" />
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog>

                <Dialog v-model:visible="productDialog_old" :style="{ width: '450px', width: '450px' }"
                    header="Year Details" :modal="true" class="p-fluid">
                    <div class="grid">
                        <div class="col-12 md:col-12">
                            <div class="field">

                            </div>
                            <div class="field">
                                <label for="enrollmenT_YEAR">Enrollement Year <i
                                        style="color: green">(eg.2022)</i></label>
                                <InputText id="enrollmenT_YEAR" v-model.trim="product.enrollmenT_YEAR" required="true"
                                    autofocus :class="{
                                        'p-invalid': submitted && !product.enrollmenT_YEAR,
                                    }" />
                            </div>
                            <div class="field">
                                <label for="exaM_YEAR">Exam Year <i style="color: green">(eg.2022-23)</i></label>
                                <InputText id="exaM_YEAR" v-model.trim="product.exaM_YEAR" required="true" autofocus
                                    :class="{ 'p-invalid': submitted && !product.exaM_YEAR }" />
                            </div>

                        </div>
                        <div class="col-12 md:col-6">

                        </div>
                        <div class="col-12 md:col-6">
                            <Button label="Cancel" icon="pi pi-times" class="p-button-danger mr-1 mb-1"
                                @click="productDialog = false" />
                        </div>
                    </div>
                </Dialog>

                <Dialog v-model:visible="deleteProductDialog" :style="{ width: '450px' }" header="Confirm"
                    :modal="true">
                    <div class="flex align-items-center justify-content-center">
                        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                        <span v-if="product">Are you sure you want to delete <b>{{ product.firsT_NAME }}</b>?</span>
                    </div>
                    <template #footer>
                        <Button label="No" icon="pi pi-times" class="p-button-text"
                            @click="deleteProductDialog = false" />
                        <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteuser" />
                    </template>
                </Dialog>

                <Dialog v-model:visible="deleteProductsDialog" :style="{ width: '450px' }" header="Confirm"
                    :modal="true">
                    <div class="flex align-items-center justify-content-center">
                        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                        <span v-if="product">Are you sure you want to delete the selected products?</span>
                    </div>
                    <template #footer>
                        <Button label="No" icon="pi pi-times" class="p-button-text"
                            @click="deleteProductsDialog = false" />
                        <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteSelectedProducts" />
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import BreadcrumbService from "../service/BreadcrumbService";
import JsonExcel from "vue-json-excel";
import myUpload from "vue-image-crop-upload";

import apis from "@/apis";
import axios from "axios";

export default {
    data() {
        return {

            show_image: false,
            width: 250,
            height: 300,
            url: "",
            params: {
                token: "123456798",
                name: "avatar",
            },
            headers: {
                smail: "*_~",
            },
            imgDataUrl: "",
            Image_data: {
                filePath: "",
                contentType: "",
            },


            show_image_poster: false,
            width_poster: 250,
            height_poster: 300,
            url_poster: "",
            params_poster: {
                token: "123456798",
                name: "avatar",
            },
            headers_poster: {
                smail: "*_~",
            },
            imgDataUrl_poster: "",
            Image_data_poster: {
                filePath: "",
                contentType: "",
            },

            
            search_category: [],
            search_singer: [],
            singer_dropdown: [],
            song_old_name: "",
            attachments_song: "",
            attachments_image: "",
            attachments_poster: "",
            new_category_name: "",
            new_category_url: "",
            new_album_name: "",
            new_album_url: "",
            addAlbumDialog: false,
            addCategoryDialog: false,
            previewImage: null,
            posterPreviewImage: null,
            preview_song_url: null,
            search_name: "",
            name: '',
            image: '',
            singer: '',
            music_composer: '',
            lyrics_writer: '',
            date: null,
            play_url: '',
            poster: '',
            album_name: '',
            category_name: '',
            user_key: "",
            client_id_dropdown: [],
            client_id_search: '',
            hide_dropdown: false,

            mobile_number: '',
            page_no: 1,
            isLoading: false,
            isLoadingModel: false,
            loading: false,
            fullPage: true,
            user_type_search: '',
            file_attachment: "",
            category_dropdown: [],
            album_dropdown: [],
            album_selected: null,
            category_selected: null,

            dropdownItems: [
                { name: "Active", value: "Active" },
                { name: "InActive", value: "InActive" },
                { name: "Deleted", value: "Deleted" },
            ],
            products: null,
            productDialog: false,
            deleteProductDialog: false,
            deleteProductsDialog: false,
            lazyParams: {},
            product: {},
            selectedProducts: null,
            filters: {},
            offset: 1,
            selectstatus: { name: "", value: "" },

            limit: 10,
            columns: [],           
            pageno: 1,
            submitted: false,
            totalRecords: 0,
            id: "",
            statuses: [
                { label: "INSTOCK", value: "instock" },
                { label: "LOWSTOCK", value: "lowstock" },
                { label: "OUTOFSTOCK", value: "outofstock" },
            ],
            BreadcrumbService: null,
            breadcrumbHome: {},
            breadcrumbItems: [],
        };
    },
    productService: null,
    async created() {
        this.productService = new ProductService();
        this.initFilters();
        this.user_key = localStorage.getItem("user_key");

        this.BreadcrumbService = new BreadcrumbService();
        let Breadcrum_data = this.BreadcrumbService.songmaster()
        this.breadcrumbHome = Breadcrum_data.home;
        this.breadcrumbItems = Breadcrum_data.items;



    },
    async mounted() {
        this.categoryList();
        this.singerList();
        this.id = this.$route.params.id;
        if (localStorage.getItem("driver")) {
            this.user_type_search = { name: localStorage.getItem("driver"), code: localStorage.getItem("driver") }
            this.hide_dropdown = true;
            localStorage.driver = '';
        }
        localStorage.driver = '';


        this.lazyParams = {
            first: 0,
            rows: this.limit,
            sortField: null,
            sortOrder: null,
            filters: this.filters,
        };
        if (this.totalRecords == 0) {
            await this.get_count();
        }
        await this.get_list();
        //alert(this.id);
    },
    watch: {
        async $route() {
            this.products = [];
            this.columns = [];
            this.totalRecords = 0;
            this.id = this.$route.params.id;
            if (this.id) {
                await this.get_count();
                await this.get_list();
            }
        },
    },
    methods: {
        // Function to check if the date is in "Month dd, yyyy" format and convert it
        convertDateFormat(dateStr) {
            // Regular expression to match "Month dd, yyyy" format
            const datePattern = /^[A-Z][a-z]+ \d{2}, \d{4}$/;

            // Check if the date string matches the pattern
            if (datePattern.test(dateStr)) {
                // Convert the original date string to a Date object
                const dateObject = new Date(dateStr);

                // Format the date to "dd/mm/yyyy"
                const day = String(dateObject.getDate()).padStart(2, '0');
                const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
                const year = dateObject.getFullYear();

                const formattedDate = `${day}/${month}/${year}`;

                return formattedDate;
            } else {
                // If the format is incorrect, return an error message
                return dateStr;
            }
        },
        toggleShow_poster() 
        {
            this.show_image_poster = !this.show_image_poster;
        },
        async cropSuccess_poster(imgDataUrl) 
        {
            this.imgDataUrl_poster = imgDataUrl;
            var substrings = imgDataUrl.split(";");
            var contentType = substrings[0].split(":");
            var type = imgDataUrl.split(";")[0].split("/")[1];
            this.handleFileUpload_thumb_with_cropper_poster(imgDataUrl,type,contentType[0]);
        },
        async handleFileUpload_thumb_with_cropper_poster(imgDataUrl, type, contentType) 
        {
            var prfeix= await this.generateString_poster();
            var filename = "Song_"+prfeix + "." + type;
            var subimgDataUrl = imgDataUrl.split(",");
            var file = await this.handleFileChange_poster(
                subimgDataUrl[1],
                contentType,
                filename
            );
            this.Image_data_poster = {
                filePath: "",
                contentType: "",
            };
            this.Image_data_poster = {
                filePath:
                "poster_image/" +
                filename,
                contentType: contentType,
            };
            this.isLoadingModel = true;
            var promise = apis.upload_to_AWS(this.Image_data_poster);
            promise.then((response) => {
                axios
                .put(response.data.data, file, {
                    headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": contentType,
                    },
                })
                .then((response) => {
                    this.isLoadingModel = false;
                    // this.$toast.add({
                    // severity: "success",
                    // summary: "success",
                    // detail: "Upload Successfully",
                    // life: 3000,
                    // });
                    // return false;
                });
            });
        },
        async generateString_poster() 
        {
            // Get the current date and time
            const currentDateTime = new Date();
            // Format the date as YYYY_MM_DD
            const formattedDate = currentDateTime.toISOString().split('T')[0].replace(/-/g, '_');
            // Format the time as HH_mm_ss
            const formattedTime = currentDateTime.toTimeString().split(' ')[0].replace(/:/g, '_');
            // Construct the final string
            const resultString = `${formattedDate}_${formattedTime}`;
            return resultString;
        },
        async handleFileChange_poster(base64, content_Type, filename) 
        {
            const base64String = base64;
            const contentType = content_Type;
            const byteCharacters = atob(base64String);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) 
            {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: contentType });
            const fileName = filename;
            var file = new File([blob], fileName, { type: contentType });
            return file;
        },









        toggleShow() 
        {
            this.show_image = !this.show_image;
        },
        async cropSuccess(imgDataUrl) 
        {
            this.imgDataUrl = imgDataUrl;
            var substrings = imgDataUrl.split(";");
            var contentType = substrings[0].split(":");
            var type = imgDataUrl.split(";")[0].split("/")[1];
            this.handleFileUpload_thumb_with_cropper(imgDataUrl,type,contentType[0]);
        },
        async handleFileUpload_thumb_with_cropper(imgDataUrl, type, contentType) 
        {
            var prfeix= await this.generateString();
            var filename = "Song_"+prfeix + "." + type;
            var subimgDataUrl = imgDataUrl.split(",");
            var file = await this.handleFileChange(
                subimgDataUrl[1],
                contentType,
                filename
            );
            this.Image_data = {
                filePath: "",
                contentType: "",
            };
            this.Image_data = {
                filePath:
                "song_image/" +
                filename,
                contentType: contentType,
            };
            this.isLoadingModel = true;
            var promise = apis.upload_to_AWS(this.Image_data);
            promise.then((response) => {
                axios
                .put(response.data.data, file, {
                    headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": contentType,
                    },
                })
                .then((response) => {
                    this.isLoadingModel = false;
                    // this.$toast.add({
                    // severity: "success",
                    // summary: "success",
                    // detail: "Upload Successfully",
                    // life: 3000,
                    // });
                    // return false;
                });
            });
        },
        async generateString() 
        {
            // Get the current date and time
            const currentDateTime = new Date();
            // Format the date as YYYY_MM_DD
            const formattedDate = currentDateTime.toISOString().split('T')[0].replace(/-/g, '_');
            // Format the time as HH_mm_ss
            const formattedTime = currentDateTime.toTimeString().split(' ')[0].replace(/:/g, '_');
            // Construct the final string
            const resultString = `${formattedDate}_${formattedTime}`;
            return resultString;
        },
        async handleFileChange(base64, content_Type, filename) 
        {
            const base64String = base64;
            const contentType = content_Type;
            const byteCharacters = atob(base64String);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) 
            {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: contentType });
            const fileName = filename;
            var file = new File([blob], fileName, { type: contentType });
            return file;
        },
        isNumber(evt) {
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                evt.preventDefault();
            }
        },

        onHide()
        {
            this.previewImage = null;
            this.posterPreviewImage = null;
            this.preview_song_url = null;
            this.album_selected = null;
            this.category_selected = null;
            this.album_dropdown=[];
            this.productDialog = false;
            this.categoryList();
        },

        async search(count) {
            if (count == 2) {
                this.search_name = "";
                this.search_singer = [];
                this.search_category = [];
                // this.category_dropdown=[];
                // this.album_dropdown=[];
                this.song_old_name = "";
                this.product = {};
                this.productDialog = false;
            }
            await this.get_list();
            await this.get_count();
        },

        async viewProduct(product) {

            console.log(JSON.stringify(product));
            await localStorage.setItem('savedata', JSON.stringify(product));
            this.$router.push({ name: "userProfile" });
        },
        dateFormat(inputDate, info) { },
        async handleFileUpload(event) {
            var fileUp = event.files[0];
            if (fileUp) {
                this.previewImage = URL.createObjectURL(fileUp);
            }
            var file = fileUp;
            this.file = file;
            var prfeix = await this.date_time_prefix();
            var filename = prfeix + "_" + file.name.replace(/\s+/g, "_");
            this.file_data = {
                filePath: 'song_image/' + filename,
                contentType: file.type,
            };
            this.isLoadingModel = true;
            var promise = apis.upload_to_AWS(this.file_data);
            promise.then((response) => {
                axios
                    .put(response.data.data, file, {
                        headers: {
                            "Access-Control-Allow-Origin": "*",
                            "Content-Type": file.type,
                        },
                    })
                    .then((response) => {
                        this.isLoadingModel = false;

                        this.attachments_image = "https://media.geoc.in/song_image/" + filename;
                        console.log(this.attachments_image);
                    });
            });
        },
        async handleFileUpload_poster(event) {
            var fileUp = event.files[0];
            if (fileUp) {
                this.posterPreviewImage = URL.createObjectURL(fileUp);
            }
            var file = fileUp;
            this.file = file;
            var prfeix = await this.date_time_prefix();
            var filename = prfeix + "_" + file.name.replace(/\s+/g, "_");
            this.file_data = {
                filePath: 'poster_image/' + filename,
                contentType: file.type,
            };
            this.isLoadingModel = true;
            var promise = apis.upload_to_AWS(this.file_data);
            promise.then((response) => {
                axios
                    .put(response.data.data, file, {
                        headers: {
                            "Access-Control-Allow-Origin": "*",
                            "Content-Type": file.type,
                        },
                    })
                    .then((response) => {
                        this.isLoadingModel = false;

                        this.attachments_poster = "https://media.geoc.in/poster_image/" + filename;
                        console.log(this.attachments_poster);
                    });
            });
        },
        async calculate_video_duration(file)
    {
          // Calculate video duration in minutes
          var videoElement = document.createElement('video');
          videoElement.preload = 'metadata';
          videoElement.src = URL.createObjectURL(file);

          videoElement.onloadedmetadata = async () => {
            window.URL.revokeObjectURL(videoElement.src);
            var durationInSeconds = videoElement.duration;
            var durationInMinutes = durationInSeconds / 60;
            this.product['duration'] = durationInMinutes.toFixed(2);
            //console.log("Video Duration: " + durationInMinutes.toFixed(2) + " minutes");
          }
    },
        async handleFileUpload_song(event) {
            var fileUp = event.files[0];
            if (fileUp) {
                this.preview_song_url = URL.createObjectURL(fileUp);
            }
            var file = fileUp;
            this.calculate_video_duration(file);
            this.file = file;
            var prfeix = await this.date_time_prefix();
            var filename = prfeix + "_" + file.name.replace(/\s+/g, "_");
            this.file_data = {
                filePath: 'songs/' + filename,
                contentType: file.type,
            };
            this.isLoadingModel = true;
            var promise = apis.upload_to_AWS(this.file_data);
            promise.then((response) => {
                axios
                    .put(response.data.data, file, {
                        headers: {
                            "Access-Control-Allow-Origin": "*",
                            "Content-Type": file.type,
                        },
                    })
                    .then((response) => {
                        this.isLoadingModel = false;
                        this.attachments_song = "https://media.geoc.in/songs/" + filename;
                        console.log(this.attachments_song);
                    });
            });
        },
        async date_time_prefix() {
            const currentDateTime = new Date();
            const formattedDate = currentDateTime
                .toISOString()
                .split("T")[0]
                .replace(/-/g, "_");
            const formattedTime = currentDateTime
                .toTimeString()
                .split(" ")[0]
                .replace(/:/g, "_");
            const resultString = `${formattedDate}_${formattedTime}`;
            return resultString;
        },
        isImage(url) {
            return /\.(jpeg|jpg|gif|png)$/i.test(url);
        },
        categoryList() {
            this.category_dropdown = [];

            var album_id = "";
            if (this.album_selected != null) {
                album_id = this.album_selected.value;
            }
            var data = {
                album_id: album_id
            };
            this.loading = true;
            var promise = apis.songCategoryList(data, this.id);
            promise.then((response) => {
                this.loading = false;
                var temp_category = response.data.data;
                for (let i = 0; i < temp_category.length; i++) {
                    if (temp_category[i]['category_name'] != "") {
                        this.category_dropdown.push({ name: temp_category[i].category_name, value: temp_category[i].album_id })
                    }
                }
                console.log("category list", this.category_dropdown);
            });
        },
        albumList() {
            this.category_dropdown = [];
            var data = {};
            this.loading = true;
            var promise = apis.songAlbumList(data, this.id);
            promise.then((response) => {
                var temp_album = response.data.data;
                this.loading = false;
                for (let i = 0; i < temp_album.length; i++) {
                    if (temp_album[i]['album_name'] != "") {
                        this.album_dropdown.push({ name: temp_album[i].album_name, value: temp_album[i]._id })
                    }
                }
                console.log("Album list", this.album_dropdown);
            });
        },
        singerList() {
            this.singer_dropdown = [];    
            var data = { };
            this.loading = true;
            var promise = apis.singerList(data, this.id);
            promise.then((response) => {
                this.loading = false;
                var temp_singer = response.data.data;
                for (let i = 0; i < temp_singer.length; i++) {
                    this.singer_dropdown.push({ name: temp_singer[i].singer_name, value: temp_singer[i]._id });
                }
                console.log("singer list", this.singer_dropdown);
            });
        },
        add_album_dl() {
            this.addAlbumDialog = true;
        },
        add_category_dl() {
            this.addCategoryDialog = true;
        },
        add_new_album() {
            var data = {
                "album_name": this.new_album_name,
                "album_url": this.new_album_url
            };
            this.isLoadingModel = true;
            var promise = apis.addAlbum(data, this.id);
            promise.then((response) => {
                this.isLoadingModel = false;
                if (response.data.status == true) {
                    this.addAlbumDialog = false;
                    this.$toast.add({ severity: 'success', summary: "Success", detail: response.data.message, life: 3000 });
                    this.albumList();
                    this.reset();
                }
                else {
                    this.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 3000 });
                }
            });
        },
        add_new_category() {
            var album_id = "";
            if (this.album_selected != null) {
                album_id = this.album_selected.value;
            }
            var data = {
                "album_id": album_id,
                "category_name": this.new_category_name,
                "category_url": this.new_category_url
            };
            this.isLoadingModel = true;
            var promise = apis.addCategory(data, this.id);
            promise.then((response) => {
                this.isLoadingModel = false;
                if (response.data.status == true) {
                    this.addCategoryDialog = false;
                    this.$toast.add({ severity: 'success', summary: "Success", detail: response.data.message, life: 3000 });
                    this.categoryList();
                    this.reset();
                }
                else {
                    this.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 3000 });
                }
            });
        },
        dateFormatDMY(inputDate) {
            var postdate = inputDate;
            if (inputDate) {
                inputDate = new Date(inputDate);
                if (inputDate.toString() == "NaN-NaN-NaN") {
                    return postdate;
                } else {
                    let date = ("0" + inputDate.getDate()).slice(-2);
                    let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
                    let year = inputDate.getFullYear();
                    if (date.toString() == "aN") {
                        return postdate;
                    } else {
                        return date + "/" + month + "/" + year;
                    }
                }
            } else {
                return "";
            }
        },
        reset() {
            this.addAlbumDialog = false;
            this.addCategoryDialog = false;
            this.new_album_name = "";
            this.new_album_url = "";
            this.new_category_name = "";
            this.new_category_url = "";
        },
        async onPage(event) {
            this.lazyParams = event;
            this.page_no = event.page + 1;
            this.limit = event.rows;
            if (this.totalRecords > 0) {
                this.get_list();
                this.get_count();
            }
        },
        get_count: function () {
            var category = [];
            var singer = [];

            if (this.search_category) {
                for (let i = 0; i < this.search_category.length; i++) {
                    category.push(this.search_category[i].name);
                }
            }

            if (this.search_singer) {
                for (let i = 0; i < this.search_singer.length; i++) {
                    singer.push(this.search_singer[i].name);
                }
            }

            var data = {
                count: true,
                name: this.search_name,
                category: category,
                singer: singer
            };
            this.loading = true;
            var promise = apis.SongList(data, this.id);
            promise.then((response) => {
                this.loading = false;
                console.log(response);
                this.totalRecords = response.data.data;
            });

            console.log(data);
        },
        get_list: function () {
            var category = [];
            var singer = [];

            if (this.search_category) {
                for (let i = 0; i < this.search_category.length; i++) {
                    category.push(this.search_category[i].name);
                }
            }
            if (this.search_singer) {
                for (let i = 0; i < this.search_singer.length; i++) {
                    singer.push(this.search_singer[i].name);
                }
            }
            var data = {
                limit: this.limit,
                page_no: this.page_no,
                count: false,
                name: this.search_name,
                category: category,
                singer: singer
            };
            this.loading = true;
            var promise = apis.SongList(data, this.id);
            promise.then((response) => {
                this.products = response.data.data;
                this.loading = false;
                if (this.columns.length == 0) {
                    if (this.products.length > 0) {
                        this.columns = Object.keys(this.products[0]);
                    }
                }
            });

            console.log(data);
        },
        async openNew() {
            this.product = {};
            this.submitted = false;
            this.albumList();
            this.productDialog = true;
            this.imgDataUrl="";
            this.Image_data = {
                filePath: "",
                contentType: "",
            };
            this.imgDataUrl_poster="";
            this.Image_data_poster = {
                filePath: "",
                contentType: "",
            };
        },
        formatCurrency(value) {
            if (value)
                return value.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                });
            return;
        },

        hideDialog() {
            this.productDialog = false;
            this.submitted = false;
        },
        async adduser() {
            this.submitted = true;
            if (!this.product.song_name) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Song name",
                    life: 3000,
                });
                return false;
            }
            if (!this.product.singer) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Singer name",
                    life: 3000,
                });
                return false;
            }

            if (!this.product.composer) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Composer name",
                    life: 3000,
                });
                return false;
            }

            if (!this.product.lyrics_writer) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Lyrics Writer",
                    life: 3000,
                });
                return false;
            }
            if (!this.product.date) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Date",
                    life: 3000,
                });
                return false;
            }
            
            
            if (!this.preview_song_url) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Upload Song",
                    life: 3000,
                });
                return false;
            }
           

            //edit
            if (this.product._id) {
                var image = this.product.song_image;
                if (this.Image_data.filePath != "") {
                    image =encodeURI("https://media.geoc.in/" +this.Image_data.filePath);
                }
                var poster = this.product.poster;
                if (this.Image_data_poster.filePath != "") {
                    poster =encodeURI("https://media.geoc.in/" +this.Image_data_poster.filePath);
                }
                var data = {
                    "album_id": this.album_selected.value,
                    "category_name": this.category_selected.name,
                    "old_name": this.song_old_name,
                    "new_name": this.product.song_name,
                    "play_url": this.attachments_song,
                    //"image_url": this.attachments_image,
                    "image_url": image,
                    //"poster_url": this.attachments_poster,
                    "poster_url": poster,
                    "singer": this.product.singer,
                    "music_composer": this.product.composer,
                    "lyrics_writer": this.product.lyrics_writer,
                    "duration": this.product.duration,
                    "date": this.dateFormatDMY(this.product.date)
                };
                this.isLoadingModel = true;
                var promise = apis.updateSong(data);
                promise
                    .then((responseapi) => {
                        this.$swal(responseapi.data.message);
                        this.isLoadingModel = false;
                        this.productDialog = false;
                        this.get_list();
                        this.get_count();
                    })
                    .catch((error) => {
                        //console.log(error);
                        this.isLoadingModel = false;
                        this.productDialog = false;
                        this.$swal.fire(error.response.data);
                        this.get_list();
                        this.get_count();
                    });
            }
            //add-----------------------------------------------------------------------------------------------------------------
            else {
                if (this.album_selected == null ) 
                {
                    this.$toast.add({
                        severity: "error",
                        summary: "error",
                        detail: "Please Select Album",
                        life: 3000,
                    });
                    return false;
                }
                if (this.category_selected == null) 
                {
                    this.$toast.add({
                        severity: "error",
                        summary: "error",
                        detail: "Please Select Category",
                        life: 3000,
                    });
                    return false;
                }

                var image = encodeURI("https://media.geoc.in/" +this.Image_data.filePath);
                var poster = encodeURI("https://media.geoc.in/" +this.Image_data_poster.filePath);
                var data1 = {
                    "album_id": this.album_selected.value,
                    "category_name": this.category_selected.name,
                    "name": this.product.song_name,
                    "play_url": this.attachments_song,
                    //"image_url": this.attachments_image,
                    "image_url": image,
                    //"poster_url": this.attachments_poster,
                    "poster_url": poster,
                    "singer": this.product.singer,
                    "music_composer": this.product.composer,
                    "lyrics_writer": this.product.lyrics_writer,
                    "duration": this.product.duration,
                    "date": this.dateFormatDMY(this.product.date)
                };
                console.log("dataaaaaaa:-", data1);
                this.isLoadingModel = true;
                var promises = apis.addSong(data1);
                promises
                    .then((response) => {
                        this.isLoadingModel = false;
                        this.productDialog = false;
                        this.$swal(response.data.message);
                        this.get_list();
                        this.get_count();
                    })
                    .catch((error) => {
                        //console.log(error);
                        this.isLoadingModel = false;
                        this.productDialog = false;
                        this.$swal.fire(error.response.data);
                        this.get_list();
                        this.get_count();
                    });
            }
        },
        async editProduct(product) {
            this.Image_data = {
                filePath: "",
                contentType: "",
            };
            this.Image_data_poster = {
                filePath: "",
                contentType: "",
            };
            this.attachments_image = "";
            this.attachments_poster = "";
            this.attachments_song = "";
            this.product = { ...product };
            console.log("Product:-", this.product);

            this.song_old_name = this.product.song_name;
            this.productDialog = true;

            this.attachments_image = this.product.song_image;
            this.imgDataUrl =  this.attachments_image;

            this.attachments_poster = this.product.poster;
            this.imgDataUrl_poster =  this.attachments_poster;

            this.attachments_song = this.product.play_url;

            this.previewImage = this.product.song_image;
            this.posterPreviewImage = this.product.poster;
            this.preview_song_url = this.product.play_url;

            this.album_selected={name:"",value:""};
            this.album_selected.value = this.product._id;
            this.album_selected.name = this.product.album_name;

            this.category_selected = {};
            this.category_selected.name = this.product.category;

         
            
                
           
        },
        confirmDeleteProduct(product) {
            this.product = product;
            console.log("product",product);
            this.deleteProductDialog = true;
        },
        deleteProduct() {
            this.products = this.products.filter((val) => val.id !== this.product.id);
            this.deleteProductDialog = false;
            this.product = {};
            this.$toast.add({
                severity: "success",
                summary: "Successful",
                detail: "Product Deleted",
                life: 3000,
            });
        },

        deleteuser() {
            if (this.product._id) {
                var data = {
                    // _id: this.product._id,
                    "album_id":this.product._id,
                    "category_name":this.product.category,
                    "song_name": this.product.song_name
                };
                this.isLoadingModel = true;
                var promise = apis.deleteSong(data);
                promise.then((responseapi) => {
                    this.isLoadingModel = false;
                    if (responseapi.data.status == true) {
                        // this.hideDialog1();
                        this.deleteProductDialog = false;
                        this.$swal(responseapi.data.message);
                        this.get_list();
                        this.get_count();
                    } else {
                        this.$swal("error to Delete Song");
                    }
                });
            }
        },
        findIndexById(id) {
            let index = -1;
            for (let i = 0; i < this.products.length; i++) {
                if (this.products[i].id === id) {
                    index = i;
                    break;
                }
            }
            return index;
        },
        createId() {
            let id = "";
            var chars =
                "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            for (var i = 0; i < 5; i++) {
                id += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return id;
        },

        async exportCSV() {
            this.limit = this.totalRecords;
            this.get_list();
            await this.$refs.dt.exportCSV();
        },
        confirmDeleteSelected() {
            this.deleteProductsDialog = true;
        },
        deleteSelectedProducts() {
            this.products = this.products.filter(
                (val) => !this.selectedProducts.includes(val)
            );
            this.deleteProductsDialog = false;
            this.selectedProducts = null;
            this.$toast.add({
                severity: "success",
                summary: "Successful",
                detail: "Products Deleted",
                life: 3000,
            });
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            };
        },
    },
    components: { downloadExcel: JsonExcel ,"my-upload": myUpload},
};
</script>

<style scoped lang="scss">
.label-gap {
    margin-bottom: 0.7rem;
}

@import "../assets/demo/badges.scss";
</style>